module.exports = __webpack_public_path__ + "static/media/fastrack_logo.95a1bbe2.png";